var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"2xl:max-w-7xl xl:max-w-7xl mx-auto py-[30px] box-border"},[_c('div',{staticClass:"text-[#101010] text-[24px] mb-[10px] font-bold text-center"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-[16px]",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }